import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import '../styles/Legal.css';

const Terms = () => {
  return (
    <div className="legal-page" data-testid="terms-page">
      <Navbar />
      
      <section className="legal-hero">
        <div className="container">
          <h1 className="page-title" data-testid="terms-title">Terms of Service</h1>
          <p className="page-subtitle" data-testid="terms-subtitle">
            Last updated: January 2025
          </p>
        </div>
      </section>

      <section className="legal-content">
        <div className="container">
          <div className="legal-container">
            <div className="legal-section">
              <h2>Agreement to Terms</h2>
              <p>
                By accessing or using our website and services, you agree to be bound by these Terms of Service and all applicable laws and regulations. If you do not agree with any of these terms, you are prohibited from using our services.
              </p>
            </div>

            <div className="legal-section">
              <h2>Services</h2>
              <p>
                BigSoftTech provides software development, web development, mobile app development, SEO, and related digital services. The specific scope of work, deliverables, timeline, and pricing will be detailed in individual project agreements.
              </p>
            </div>

            <div className="legal-section">
              <h2>Project Agreements</h2>
              <p>
                All projects require a signed agreement that specifies:
              </p>
              <ul>
                <li>Project scope and deliverables</li>
                <li>Timeline and milestones</li>
                <li>Payment terms and schedule</li>
                <li>Intellectual property rights</li>
                <li>Confidentiality obligations</li>
                <li>Support and maintenance terms</li>
              </ul>
            </div>

            <div className="legal-section">
              <h2>Payment Terms</h2>
              <p>
                Payment terms vary by engagement model:
              </p>
              <ul>
                <li><strong>Fixed Projects:</strong> Milestone-based payments as specified in the agreement</li>
                <li><strong>Time & Materials:</strong> Invoiced monthly based on hours worked</li>
                <li><strong>Retainer:</strong> Monthly fixed fee paid in advance</li>
              </ul>
              <p>
                Late payments may incur interest charges and may result in suspension of services. All prices are in Indian Rupees (INR).
              </p>
            </div>

            <div className="legal-section">
              <h2>Intellectual Property</h2>
              <p>
                Upon full payment, you will own the final deliverables created specifically for your project. BigSoftTech retains ownership of:
              </p>
              <ul>
                <li>Pre-existing code and components</li>
                <li>Development tools and frameworks</li>
                <li>General methodologies and processes</li>
              </ul>
            </div>

            <div className="legal-section">
              <h2>Confidentiality</h2>
              <p>
                Both parties agree to keep confidential information disclosed during the engagement private and secure. This obligation continues for 3 years after project completion.
              </p>
            </div>

            <div className="legal-section">
              <h2>Warranties and Limitations</h2>
              <p>
                We warrant that our services will be performed in a professional and workmanlike manner. However, we do not guarantee that:
              </p>
              <ul>
                <li>Software will be error-free or uninterrupted</li>
                <li>Specific business results or outcomes will be achieved</li>
                <li>Third-party services integrated will remain available</li>
              </ul>
            </div>

            <div className="legal-section">
              <h2>Limitation of Liability</h2>
              <p>
                Our total liability for any claims arising from our services shall not exceed the total amount paid by you in the 12 months preceding the claim.
              </p>
            </div>

            <div className="legal-section">
              <h2>Termination</h2>
              <p>
                Either party may terminate the engagement with 30 days written notice. Upon termination, you will be billed for work completed to date.
              </p>
            </div>

            <div className="legal-section">
              <h2>Changes to Terms</h2>
              <p>
                We reserve the right to modify these terms at any time. Changes will be effective immediately upon posting to this page. Your continued use of our services constitutes acceptance of any changes.
              </p>
            </div>

            <div className="legal-section">
              <h2>Governing Law</h2>
              <p>
                These terms shall be governed by and construed in accordance with the laws of India. Any disputes shall be subject to the exclusive jurisdiction of courts in Prayagraj or Noida, Uttar Pradesh, India.
              </p>
            </div>

            <div className="legal-section">
              <h2>Contact Information</h2>
              <p>
                For questions about these Terms of Service, please contact us at:
                <br />
                <strong>Email:</strong> contact@BigSoftTech.in
                <br />
                <strong>Phone:</strong> 05324050303                <br />
                <strong>Offices:</strong> Prayagraj (Civil Lines) & Noida (Sector 62), Uttar Pradesh, India
              </p>
            </div>
          </div>
        </div>
      </section>

\    </div>
  );
};

export default Terms;